import React from "react";

function Screen() {

    return (
        <section className="page3">
            <div className="gif-div">
                <h3 className="gif-title">You may to be a hero, Why not ? </h3>
            </div>
            <div className="gif">
                <div className="gif-frame">
                    <img className="gif-img" src="././images/starwarsgif.gif" />
                    <h3>Armadillos Stars</h3>
                </div>
                <div className="gif-frame">
                    <img className="gif-img" src="././images/herosGif.gif" />
                    <h3>Armadillos Heroes</h3>
                </div>
                <div className="gif-frame">
                    <img className="gif-img" src="././images/bladesgif.gif" />
                    <h3>Armadillos Blades</h3>
                </div>
            </div>
        </section>
    )

}

export default Screen